import React from 'react';

const Component = props => {

   return (
       <div className='ToolTip'>
            <span><b>Jockey name: </b>{props.metadata ? props.metadata["JOCKEY_NAME"] : null ? props.metadata["JOCKEY_NAME"] : ""}</span><br />
            <span><b>Saddlecloth number: </b>{props.metadata ? props.metadata["CLOTH_NUMBER_ALPHA"] : null ? props.metadata["CLOTH_NUMBER_ALPHA"] : ""}</span><br />
            <span><b>Stall draw: </b>{props.metadata ? props.metadata["STALL_DRAW"] : null ? props.metadata["STALL_DRAW"] : ""}</span><br />
            <span><b>Trainer: </b>{props.metadata ? props.metadata["TRAINER_NAME"] : null ? props.metadata["TRAINER_NAME"] : ""}</span><br />
            <span><b>Age: </b>{props.metadata ? props.metadata["AGE"] : null ? props.metadata["AGE"] : ""}</span><br />
            <span><b>Weight: </b>{props.metadata ? props.metadata["WEIGHT_VALUE"] : null ? props.metadata["WEIGHT_VALUE"] : ""}</span><br />
            <span><b>Form: </b>{props.metadata ? props.metadata["FORM"] : null ? props.metadata["FORM"] : ""}</span><br />
            <span><b>Days since last run: </b>{props.metadata ? props.metadata["DAYS_SINCE_LAST_RUN"] : null ? props.metadata["DAYS_SINCE_LAST_RUN"] : ""}</span><br />
            <span><b>Jockey claim: </b>{props.metadata ? props.metadata["JOCKEY_CLAIM"] : null ? props.metadata["JOCKEY_CLAIM"] : ""}</span><br />
            <span><b>Wearing: </b>{props.metadata ? props.metadata["WEARING"] : null ? props.metadata["WEARING"] : ""}</span><br />
            <span><b>Volume Matched: </b>{props.volumeMatched != null ? props.volumeMatched.toFixed(2) : ""}</span><br />
       </div>
   );
}

export default Component;